<template>
  <div id="technology-bom">
    <template v-if="showPage == 1">
      <el-card class="table_searchbar">
        <el-row style="margin-bottom: 20px">
          <el-col :span="5">
            <div>
              <span class="title">物料编码：</span>
              <el-input
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                size="small"
                v-model="searchForm.materialCode"
                maxlength="100"
                placeholder="物料编码"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span
                class="title"
                :style="W ? { marginLeft: '' } : { marginLeft: '-35px' }"
                >物料名称：</span
              >
              <el-input
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                size="small"
                v-model="searchForm.materialName"
                maxlength="100"
                placeholder="物料名称"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span
                class="title"
                :style="W ? { marginLeft: '' } : { marginLeft: '-35px' }"
                >工艺编码：</span
              >
              <el-input
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                size="small"
                v-model="searchForm.technologyCode"
                maxlength="100"
                placeholder="工艺编码"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span
                class="title"
                :style="W ? { marginLeft: '' } : { marginLeft: '-60px' }"
                >创建日期：</span
              >
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="searchForm.date"
                type="daterange"
                :style="W ? { width: '230px' } : { width: '130px' }"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <a
              style="margin-right: 12px; cursor: pointer; font-size: 12px"
              @click="toggleShowMore"
            >
              {{ showMore ? "收起" : "展开" }}
              <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
            </a>
            <el-button
              icon="el-icon-search"
              size="mini"
              type="primary"
              @click="clickSearch"
              >查询</el-button
            >
            <el-button
              style="margin-left: 9px"
              icon="el-icon-refresh"
              size="mini"
              @click="resetSearch"
              >重置</el-button
            >
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showMore">
            <el-row style="margin-bottom: 20px">
              <el-col :span="5">
                <div>
                  <span
                    class="title"
                    :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                    >机组名称：</span
                  >
                  <el-select
                    filterable
                    v-model="searchForm.factoryModelNames"
                    placeholder="机组名称"
                    clearable
                    :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                  >
                    <el-option
                      v-for="item in factoryModelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5">
                <div>
                  <span
                    class="title"
                    :style="W ? { marginLeft: '' } : { marginLeft: '-35px' }"
                    >存货代码：</span
                  >
                  <el-input
                    :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                    size="small"
                    v-model="searchForm.inventoryCode"
                    maxlength="100"
                    placeholder="存货代码"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="">
                  <span
                    class="title"
                    :style="W ? { marginLeft: '' } : { marginLeft: '-35px' }"
                    >物料类型：</span
                  >
                  <el-select
                    size="small"
                    :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                    clearable
                    v-model="searchForm.materialTypeCode"
                    placeholder="物料类型"
                    filterable
                  >
                    <el-option
                      v-for="item in materialTypeOption"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="">
                  <span
                    class="title"
                    :style="W ? { marginLeft: '' } : { marginLeft: '-60px' }"
                    >物料规格：</span
                  >
                  <el-input
                    size="small"
                    :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
                    clearable
                    v-model="searchForm.specification"
                    maxlength="50"
                    placeholder="物料规格"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
      </el-card>

      <el-card class="table-card">
        <div class="table_common_operbar" style="margin-bottom: 20px">
          <el-row>
            <el-button
              v-if="permission.btn_technology_params_model"
              style="display: inline-block"
              size="small"
              type="primary"
              @click="showAddTechnology"
              >工艺参数模板配置</el-button
            >
            <!-- <el-upload style="display: inline-block;" accept=".xls, .xlsx" class="import_upload" v-if="permission.btn_technology_import" :action="importUrl()" :before-upload="beforeLoad" :on-success="uploadTemplateComplete" :show-file-list="false">
                            <el-button icon="el-icon-upload el-icon--left" type="primary" size="small">导入工艺</el-button>
                        </el-upload> -->

            <!-- <el-dropdown>
              <span class="el-dropdown-link">
                <el-button icon="el-icon-upload el-icon--left" type="primary" size="small">导入工艺</el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-upload
                    style="display: inline-block;"
                    accept=".xls, .xlsx"
                    class="import_upload"
                    v-if="permission.btn_technology_import"
                    :action="importUrl()"
                    :before-upload="beforeLoad"
                    :on-success="uploadTemplateComplete"
                    :show-file-list="false"
                  >
                    <el-button style="width:140px" icon="el-icon-upload el-icon--left" type="primary" size="small">工艺导入</el-button>
                  </el-upload>
                </el-dropdown-item>
                <el-dropdown-item style="margin-top:10px">
                  <el-upload
                    style="display: inline-block;"
                    accept=".xls, .xlsx"
                    class="import_upload"
                    v-if="permission.btn_technology_import"
                    :action="importUrl(1)"
                    :before-upload="beforeLoad"
                    :on-success="uploadTemplateComplete"
                    :show-file-list="false"
                  >
                    <el-button icon="el-icon-upload el-icon--left" type="primary" size="small">模版批量导入</el-button>
                  </el-upload>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <!-- <div style="display: inline-block;" class="import_upload" v-if="permission.btn_technology_sampleDownload">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <el-button size="small">
                    模板下载
                    <i class="el-icon-download el-icon--right"></i>
                  </el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <a class="import_upload" href="/api/technology/sampleDownload">
                      <el-button type="primary" style="width:140px" size="small">工艺导入<i class="el-icon-download el-icon--right"></i></el-button>
                    </a>
                  </el-dropdown-item>
                  <el-dropdown-item style="margin-top:10px">
                    <a class="import_upload" href="/api/technology/technologyTemplateDownload">
                      <el-button type="primary" size="small">模版批量导入<i class="el-icon-download el-icon--right"></i></el-button>
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
          </el-row>
        </div>

        <el-table :data="tableList" style="width: 100%">
          <el-table-column
            show-overflow-tooltip
            prop="technologyCode"
            label="工艺编码"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="technologyRouteName"
            label="工艺路线名称"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="materialCode"
            label="物料编码"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="materialName"
            label="物料名称"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="specification"
            label="物料规格"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="materialType"
            :formatter="parseType"
            label="物料类型"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="inventoryCode"
            label="存货代码"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="factoryModelNames"
            label="机组名称"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            :formatter="parseState"
            label="状态"
          >
            <template slot-scope="scope">
              <span :style="{ color: parseStyle(scope.row) }">{{
                parseState(scope.row)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createUserName"
            label="创建者"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="checkUserName"
            label="审核者"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="gmtModified"
            :formatter="$commonUtil.changeToDate"
            label="更新时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="gmtCreate"
            :formatter="$commonUtil.changeToDate"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作" min-width="210">
            <template slot-scope="scope">
              <el-switch
                v-if="permission.btn_technology_update"
                :active-text="scope.row.isEnable ? '禁用' : '启用'"
                style="margin-right: 10px"
                v-model="scope.row.isEnable"
                @change="changeEnable($event, scope.row)"
                active-color="#13ce66"
                inactive-color="#ccc"
              ></el-switch>
              <el-button type="text" size="small" @click="showViewDialog(scope.row)"
                >查看</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="permission.btn_technology_update"
                @click="showEditDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                class="btn-del"
                type="text"
                size="small"
                v-if="permission.btn_technology_update"
                @click="deleteTechnology(scope.row)"
                >删除</el-button
              >
              <el-button type="text" size="small" @click="exportTechnology(scope.row)"
                >导出</el-button
              >
              <el-button
                @click="checkTechnology(scope.row)"
                type="text"
                size="small"
                v-if="permission.btn_technology_check && scope.row.state == 0"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <div class="total_page">
            <span> 共{{ page.total }}条 10条/页</span>
          </div>
          <div
            style="margin-top: 3px; text-align: right; margin-bottom: 20px"
            v-if="tableList.length > 0"
          >
            <el-pagination
              background
              layout="prev, pager, next"
              :total="page.total"
              @current-change="handleCurrentChange"
              :current-page="page.pageNum"
            ></el-pagination>
          </div>
        </div>
      </el-card>
      <!-- 工艺批量导入提示框开始 -->
      <el-dialog
        title="导入详情"
        style="z-index: 99999999999"
        :close-on-click-modal="false"
        :visible.sync="exportDialogVisible"
        :width="W ? '25%' : '30%'"
        center
      >
        <div class="exprot_info">
          <el-row :gutter="20">
            <span>总共导入工艺条数：</span>
            <span>{{ exportInfo.total }}条</span>
          </el-row>
          <el-row :gutter="20">
            <span>导入工艺成功条数：</span>
            <span>{{ exportInfo.success }}条</span>
          </el-row>
          <el-row :gutter="20">
            <span>导入工艺失败条数：</span>
            <span>{{ exportInfo.fail }}条</span>
          </el-row>
          <!-- <el-row :gutter="20" >
                            <span>导入工序失败条数：</span>
                            <span>{{exportInfo.processFail}}条</span>
                        </el-row>
                        <el-row :gutter="20" >
                            <span>导入参数失败条数：</span>
                            <span>{{exportInfo.paramsFail}}条</span>
                        </el-row> -->
        </div>
        <span slot="footer" class="el-dialog__footer" style="text-align: center" center>
          <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
            <el-button type="primary">下载失败数据</el-button>
          </a>
          <el-button
            type="primary"
            style="margin-left: 10px"
            @click="
              () => {
                this.exportDialogVisible = false;
              }
            "
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 工艺批量导入提示框结束 -->
    </template>

    <template v-if="showPage == 2">
      <AddTechnology ref="addTechnology" />
    </template>

    <template v-if="showPage == 3">
      <EditTechnology :itemData="itemData" />
    </template>
    <template v-if="showPage == 4">
      <ViewTechnology :itemData="itemData" />
    </template>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import ViewTechnology from "./ViewTechnology.vue";
import AddTechnology from "./AddTechnology.vue";
import EditTechnology from "./EditTechnology.vue";

export default {
  name: "Technology",
  data() {
    return {
      materialTypeOption: [],
      showMore: false,
      itemData: {},
      showPage: 1,
      // 分页
      page: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
        // currentPage:0
      },
      searchForm: {
        materialName: "",
        materialCode: "",
        technologyCode: "",
        date: [],
        factoryModelNames: null,
        specification: "",
        materialTypeCode: "",
        inventoryCode: "",
      },
      W: "",
      tableList: [],
      // 状态
      optionsStatus: [
        { status: 0, label: "已审核" },
        { status: 1, label: "未审核" },
        { status: 2, label: "已完成" },
        { status: 3, label: "已取消" },
      ],
      // 物料类型
      optionsType: [
        { status: 0, label: "零件" },
        { status: 1, label: "机床" },
      ],
      //
      addForm: {},
      // 物料下拉数据
      materiaList: [],
      // 添加
      addDialogVisible: false,

      orderType: "DESC", //排序类型
      orderColumn: "gmtCreate", //排序列
      defaultSort: { prop: "gmtCreate", order: "descending" }, //默认排序设置
      searchCopy: {},
      selectAll: false,
      isSyncSalary: false,
      fristLoad: false,
      nameType: {
        TitleType: "",
        Approve: "",
      },
      qcTemplateList: [],
      loading: false,
      exportInfo: {
        success: 0,
        fail: 0,
        url: null,
        total: 0,
        processFail: 0,
        paramsFail: 0,
      },
      exportDialogVisible: false,
      W: false,
      product: [],
      device: [],
      defaultDeviceType: 15,
      deviceType: [],
      tableData: [],
      tableCurrentPage: 1,
      tableTotalPage: 100,
      rules: {
        technologyNo: [{ required: true, message: "请输入工艺编号", trigger: "blur" }],
        productModel: [{ required: true, message: "请选择型号", trigger: "blur" }],
        materialId: [{ required: true, message: "请选择物料编码", trigger: "blur" }],
        deviceType: [{ required: true, message: "请选择设备类型", trigger: "blur" }],
        procedureName: [{ required: true, message: "请输入工序名称", trigger: "blur" }],
        routeName: [{ required: true, message: "请输入工艺路线名称", trigger: "blur" }],
        procedureCode: [{ required: true, message: "请输入工序编号", trigger: "blur" }],
      },
      factoryModelList: [],
      permission: JSON.parse(localStorage.getItem("permission")),
    };
  },
  components: {
    ViewTechnology,
    AddTechnology,
    EditTechnology,
  },
  filters: {
    date(time) {
      let oldDate = new Date(time);
      let newDate = new Date();
      var dayNum = "";
      var getTime = (newDate.getTime() - oldDate.getTime()) / 1000;

      if (getTime < 60 * 5) {
        dayNum = "";
      } else if (getTime >= 60 * 5 && getTime < 60 * 60) {
        dayNum = parseInt(getTime / 60);
      } else if (getTime >= 3600 && getTime < 3600 * 24) {
        dayNum = parseInt(getTime / 3600);
      } else if (getTime >= 3600 * 24 && getTime < 3600 * 24 * 30) {
        dayNum = parseInt(getTime / 3600 / 24);
      } else if (getTime >= 3600 * 24 * 30 && getTime < 3600 * 24 * 30 * 12) {
        dayNum = parseInt(getTime / 3600 / 24 / 30);
      } else if (time >= 3600 * 24 * 30 * 12) {
        dayNum = parseInt(getTime / 3600 / 24 / 30 / 12);
      }

      let year = oldDate.getFullYear();
      let month = oldDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = oldDate.getDate();
      day = day < 10 ? "0" + day : day;
      let hour = oldDate.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let minute = oldDate.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      let second = oldDate.getSeconds();
      second = second < 10 ? "0" + second : second;
      return (
        " " + year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
      );
    },
  },
  created: function () {
    this.search();
  },
  mounted: function () {
    this.getDict("materialType");
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.loadQcTemplateList();
    this.loadDeviceTypeList();
    this.loadFactoryModelList();
  },

  methods: {
    getDict(dict) {
      this.$RequestUtil.get({
        url: "/api/pull/list/list-dic",
        type: "sync",
        params: {
          bizCode: dict,
        },
        success: (res) => {
          this[dict + "Option"] = res.data;
        },
      });
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    async loadFactoryModelList() {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/getWorkShopList",
        params: {},
      });
      this.factoryModelList = data;
    },

    importUrl(type) {
      if (type) {
        return `/api/technology/importTechnologyList?token=${localStorage.getItem(
          "token"
        )}`;
      }
      return `/api/technology/importTechnology?token=${localStorage.getItem("token")}`;
    },
    beforeLoad(file) {
      let fileSize = file.size / 1024 / 1024;
      fileSize = Math.round(fileSize * 100) / 100;
      if (fileSize >= 5) {
        this.$message({
          type: "error",
          message: `文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`,
        });
        return false;
      }
      this.$RequestUtil.loading();
    },
    uploadTemplateComplete: function (response, file, fileList) {
      this.$RequestUtil.loading().close();
      if (response != null) {
        if (response.code == 0) {
          log("查看导入信息", response);
          this.exportInfo.url = response.data.url;
          this.exportInfo.success = response.data.success;
          this.exportInfo.fail = response.data.fail;
          this.exportInfo.total =
            Number(response.data.fail) + Number(response.data.success);
          // if(response.data.duleResVOS){
          //     this.exportInfo.processFail=response.data.duleResVOS[1].fail
          //     this.exportInfo.paramsFail=response.data.duleResVOS[2].fail
          // }
          this.exportDialogVisible = true;
          this.initTable();
        } else if (response.code == -1) {
          this.$message({
            type: "error",
            message: response.msg,
          });
        } else if (response.code == 10) {
          this.$message({
            type: "error",
            message: "登入过期！",
          });
          this.$router.push({ path: "/Login", name: "Login" });
          return;
        }
      }
    },
    showAddTechnology() {
      this.showPage = 2;
    },
    resetSearch() {
      this.searchForm = {
        materialName: "",
        materialCode: "",
        technologyCode: "",
        factoryModelNames: null,
        specification: "",
        materialTypeCode: "",
        inventoryCode: "",
        date: [],
      };
      this.search(1);
    },
    checkTechnology: function (rowData) {
      this.$confirm("确认审核通过该工艺?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/technology/checkTechnology",
          params: { id: rowData.id },
          success: (res) => {
            if (res.code == 0) {
              this.$message({ type: "success", message: "审核通过!" });
              this.initTable();
            } else {
              this.$message({ type: "error", message: res.msg || res.message });
            }
          },
        });
      });
    },
    showEditDialog: function (rowData) {
      this.itemData = rowData;
      this.showPage = 3;
    },
    showViewDialog(rowData) {
      this.itemData = rowData;
      this.showPage = 4;
    },
    // 页/条
    handleSizeChange(pageSize) {
      log(pageSize);
      this.page.pageSize = pageSize;
      this.search();
    },
    // 当前页
    handleCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.search(pageNum);
    },
    parseState: function (val) {
      if (val.state == 0) {
        return "未审核";
      } else {
        return "已审核";
      }
    },
    parseStyle(rowData) {
      if (rowData.state == 0) {
        return "red";
      } else {
        return "green";
      }
    },

    parseType: function (rowData) {
      if (rowData.materialTypeCode != null) {
        const type = this.materialTypeOption.find(
          (e) => e.key == rowData.materialTypeCode
        );
        if (type) {
          return type.name;
        }
      }
    },

    clickSearch() {
      this.search(1);
    },

    // 搜索
    search: function (pageNum) {
      if (pageNum) {
        this.$set(this.page, "pageNum", pageNum);
      }

      this.$RequestUtil.get({
        url: "/api/technology/listTechnology",
        type: "sync",
        params: {
          pageNum: this.page.pageNum,
          pageSize: 10,
          technologyCode: this.searchForm.technologyCode,
          materialCode: this.searchForm.materialCode,
          factoryModelNames: this.searchForm.factoryModelNames,
          materialName: this.searchForm.materialName,
          createTimeStart: this.searchForm.date ? this.searchForm.date[0] : null,
          createTimeEnd: this.searchForm.date ? this.searchForm.date[1] : null,
          specification: this.searchForm.specification,
          materialTypeCode: this.searchForm.materialTypeCode,
          inventoryCode: this.searchForm.inventoryCode,
        },
        success: (res) => {
          if (res.msg == "success") {
            this.tableList = res.data;
            this.page.total = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        },
      });
    },

    deleteTechnology: function (rowData) {
      this.$confirm("此操作将删除该工艺, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/technology/removeTechnology",
          type: "sync",
          params: {
            id: rowData.id,
          },
          success: (res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.initTable();
            } else if (res.code == -1) {
              this.$message({
                type: "error",
                message: "该工艺正在使用中，不可删除!",
              });
            }
          },
        });
      });
    },
    exportTechnology: function (rowData) {
      this.$confirm("此操作将导出该工艺, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          id: rowData.id,
          token: localStorage.getItem("token"),
        };
        let str = "?";
        for (let p in params) {
          if (params[p] || params[p] === 0) {
            str += `${p}=${params[p]}&`;
          }
        }
        let { code, data } = await this.$RequestUtil.getAsync({
          url: "/api/auth/checkToken",
          type: "sync",
          params: {},
        });
        if (data == 0 || code != 0) {
          this.$message.error("当前登录已过期");
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("permission");
          this.$router.push({ path: "/login" });
          return;
        }
        if (str.endsWith("&")) {
          str = str.slice(0, str.length - 1);
          window.location.href = "/api/technology/exportTechnology" + str;
        }
      });
    },
    async changeEnable(ev, row) {
      let isEnable = 0;
      let str = "禁用成功";
      if (ev) {
        isEnable = 1;
        str = "启用成功";
      }
      let { code, data, msg, message } = await this.$RequestUtil.postAsync({
        url: "/api/technology/enableTechnology ",
        type: "sync",
        params: { id: row.id, isEnable },
      });
      if (code == 0) {
        this.$message.success(str);
        this.search();
      } else {
        this.$message.error(msg || message);
      }
    },
    // 获取物料名称下拉选项
    async getMlist(materialName, materialCode) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: {
          materialName,
          materialCode,
        },
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      this.materiaList = res.data;
    },

    // 分页
    pageChange(pageNum) {
      // this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCopy));
      this.search(pageNum);
    },

    // 获取物料名称下拉选项
    async loadMaterialList(materialName, materialCode) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: { materialName, materialCode },
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      return res.data;
    },
    async remoteMethod(materialName, materialCode) {
      this.materiaList = await this.loadMaterialList(materialName, materialCode);
    },

    initTable: function () {
      this.search();
    },

    fatherMethod() {
      this.search();
    },

    loadQcTemplateList() {
      this.$RequestUtil.get({
        url: "/api/select/listQcTemplates",

        params: {},
        success: (res) => {
          if (res.code != -1) {
            this.qcTemplateList = res.data;
          }
        },
      });
    },

    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",
        params: {},
      });
      if (code == 0) {
        this.deviceType = data;
      } else {
        this.$message.error(msg || message);
      }
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
.exprot_info {
  text-align: center;
}
.page {
  display: flex;
  justify-content: flex-end;
}
.key {
  font-size: 16px;
  color: #c0c4cc;
  font-family: NotoSansHans-Regula;
  padding-right: 10px;
}
.value {
  font-size: 16px;
  color: #999;
  font-family: NotoSansHans-Regula;
}
.y_technology_flex {
  display: flex;
}
.y_flex_Cart {
  width: 100px !important;
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
@media screen and (max-width: 1440px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
</style>
<style>
#technology-bom .el-date-editor.el-input,
#technology-bom .el-date-editor.el-input__inner {
  width: 216px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/Technology.vue